module.exports = __webpack_public_path__ + "static/media/belden_logo.1b69775d.svg";